<template>
    <div>
        <table v-if="!loading && machines.length">
            <thead>
                <tr>
                    <th>#</th>
                    <th>Nome</th>
                    <th>Categoria</th>
                    <th>Ultima atualização</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(mac, index) in machines" :key="index">
                    <td>{{ index+1 }}</td>
                    <td>{{ mac.shortName }}</td>
                    <td>{{ mac.category.name }}</td>
                    <td>
                        <template v-if="mac.lastUpdate">{{ $moment(mac.lastUpdate,'X').format('DD/MM/YYYY HH:mm') }}</template>
                        <template v-else>{{ $moment(mac.createdAt,'X').format('DD/MM/YYYY HH:mm') }}</template>
                    </td>
                    <td>
                        <button @click="openForm(index)"><i class="ico-createmode_editedit"></i></button>
                        <button @click="deleteItem(mac.docId)" class="red warning bg-warning"><i class="ico-delete"></i></button>
                    </td>
                </tr>
            </tbody>
        </table>
        <p v-if="loading">Carregando...</p>
        <p v-if="!loading && !machines.length"><strong>Nenhum registro</strong></p>
        <button class="button" @click="edit= true">Adicionar</button>
        <modal :show="edit" v-model="edit">
            <div slot="body">
                <machine :machine="machine" v-if="edit" :callback="loadList"></machine>
            </div>
        </modal>

    </div>
</template>
<script>
import Machine from './Form.vue'
import Modal from '../../components/Modal'
export default {
    name: 'MachinesList',
    components: {
        Machine,
        Modal
    },
    data(){
        return{
            loading: false,
            machines: [],
            machine: {},
            edit: false
        }
    },
    watch: {
        edit: {
            handler(nV){
                if(!nV){
                    this.machine = {}
                }
            }
        }
    },
    mounted(){
        this.loadList()
    },
    methods: {
        loadList(){
            this.edit = false
            this.machine = {}
            this.loading = true
            this.$db.collection("machines").get()
            .then((snap) => {
                let machine = []
                this.loading = true
                snap.forEach((doc) => {
                    let data = doc.data()
                    data.docId = doc.id
                    machine.push(data)
                });

                this.machines = machine
                this.loading = false
            })
        },
        deleteItem(doc){
            this.$db.collection("machines").doc(doc).delete().then(() => {
                this.loadList()
                this.$root.alerts.push({msg: 'Máquina removida com sucesso', type: 'success'})
            }).catch((error) => {
                console.error(error)
                this.$root.alerts.push({msg: 'Houve um erro ao remover a máquina', type: 'error'})
            });
        },
        openForm(index){
            this.machine = this.machines[index]
            this.edit = true
        }
    }
}
</script>  